(function () {
  function updateVariantState(select) {
    const form = select.closest('form');
    if (!form) return;
    const option = select.options[select.selectedIndex];
    if (!option) return;
    const price = form.querySelector('[data-variant-price]');
    const compare = form.querySelector('[data-variant-compare-price]');
    const inventory = form.querySelector('[data-variant-inventory]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
    if (compare) {
      compare.textContent = option.dataset.comparePrice || '';
      compare.hidden = !option.dataset.comparePrice;
    }
    if (inventory) {
      inventory.textContent = option.dataset.inventory || '';
      inventory.hidden = !option.dataset.inventory;
    }
  }
  document.addEventListener('change', function (event) {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    updateVariantState(select);
  });
})();
